import React, { useEffect, useState } from 'react';
import AgendamentoMedicoRenachIntegrado from 'pages/DetranCnh/components/pages/AgendamentoMedicoRenachIntegrado';

import { ROUTE_DETRAN_CNH_ESTRANGEIRO_AGENDAMENTO_PSICOLOGICO } from 'pages/DetranCnh/routes/paths';

// REDUX
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';

// FORM
import { consultaCategoriaRequest } from 'store/modules/api/detranCnh/consulta/categoria/actions';
import { initialValues, dadosCidadao } from './form';

const AgendamentoMedicoCnhEstrangeiro: React.FC = () => {
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(true);

	const { saveGerarRenach } = useSelector(
		(state: ApplicationState) => state.api.detranCnh.sockets,
	);

	const consultaCategoria = useSelector(
		(state: ApplicationState) => state.api.detranCnh.consulta.consultaCategoria,
	);

	useEffect(() => {
		dispatch(consultaCategoriaRequest({ funcionalidade: 'cnh_estrangeira' }));
	}, [dispatch]);

	useEffect(() => {
		if (saveGerarRenach.data?.gerarRenachBase) {
			const {
				cpf,
				logradouroCep,
				codCiretranHabilitacao,
				categoriaPretendida,
			} = saveGerarRenach.data.gerarRenachBase;

			initialValues.categoria_pretendida =
				consultaCategoria.divisaoEquitativa?.filter(
					divisaoEquitativa => divisaoEquitativa.codigo === categoriaPretendida,
				)[0]?.codigoDivisaoEquitativa || categoriaPretendida;
			initialValues.cpf_cidadao = Number(cpf);
			initialValues.cep_cidadao = Number(logradouroCep);
			initialValues.codigo_ciretran_exame_medico = Number(
				codCiretranHabilitacao,
			);
		}
	}, [consultaCategoria.divisaoEquitativa, saveGerarRenach.data]);

	useEffect(() => {
		if (saveGerarRenach.data?.gerarRenachBase) {
			const {
				cpf,
				rneNumero,
				nome,
				nomeSocial,
				nomePai,
				nomeMae,
				numDocumento,
				dataNascimento,
				sexo,
				nacionalidade,
				codigoNaturalidade,
				categoriaPretendida,
				logradouroCep,
				flagDeficienteFisico,
			} = saveGerarRenach.data.gerarRenachBase;

			// DADOS CIDADÃO
			dadosCidadao.nome = nomeSocial || nome;
			dadosCidadao.nomeMae = nomeMae;
			dadosCidadao.nomePai = nomePai;
			dadosCidadao.numeroRg = numDocumento;
			dadosCidadao.cpf = cpf;
			dadosCidadao.rne = rneNumero || '';
			dadosCidadao.sexo = sexo;
			dadosCidadao.nacionalidade = nacionalidade;
			dadosCidadao.cep = logradouroCep;
			dadosCidadao.dataNascimento = dataNascimento;
			dadosCidadao.naturalidade = codigoNaturalidade || '';
			dadosCidadao.categoriaPretendida =
				consultaCategoria.divisaoEquitativa?.filter(
					divisaoEquitativa => divisaoEquitativa.codigo === categoriaPretendida,
				)[0]?.codigoDivisaoEquitativa || categoriaPretendida;
			dadosCidadao.isPortadorNecessidadesEspeciais =
				!!flagDeficienteFisico || flagDeficienteFisico === 'S';
			setIsLoading(false);
		}
	}, [consultaCategoria.divisaoEquitativa, saveGerarRenach.data]);

	return (
		<>
			{!isLoading && (
				<AgendamentoMedicoRenachIntegrado
					dadosAgendamento={initialValues}
					dadosCidadao={dadosCidadao}
					redirecionamento={
						ROUTE_DETRAN_CNH_ESTRANGEIRO_AGENDAMENTO_PSICOLOGICO
					}
				/>
			)}
		</>
	);
};
export default AgendamentoMedicoCnhEstrangeiro;
